import React from 'react'

function DesignSection() {
  return (
    <section className="ttm-row padding_top_zero-section ttm-bgcolor-grey bg-layer-equal-height mb_20 res-991-mb_60 clearfix">
    <div className="container">
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="row no-gutters">
            <div className="col-lg-7 col-md-12">
              <div className="ttm-bg ttm-col-bgcolor-yes ttm-bgcolor-darkgrey ttm-bg ttm-left-span spacing-9">
                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                  <div className="ttm-col-wrapper-bg-layer-inner" />
                </div>
                <div className="layer-content">
                  {/* section title */}
                  <div className="section-title">
                    <div className="title-header">
                      <h3>WELL DESIGNED</h3>
                      <h2 className="title">We Provide <b>More Than Just Stitched Fabric — We Deliver Style</b></h2>
                    </div>
                    <div className="title-desc">
                      <p>NASK International is a leading textile sourcing, manufacturing, and exporting company, committed to advancing sustainable material sourcing in the apparel and home textile sectors. Alongside its regular production, NASK International has become one of the largest exporters, supporting global efforts toward sustainability and innovation.</p>
                    </div>
                  </div>{/* section title end */}
                  <div className="padding_top15">
                    {/* ttm-progress-bar */}
                    <div className="ttm-progress-bar" data-percent="90%">
                      <div className="progressbar-title">Textile</div>
                      <div className="progress-bar-inner">
                        <div className="progress-bar progress-bar-color-bar_skincolor">
                          <div className="progress-bar-percent ttm-bgcolor-skincolor" data-percentage={90}>90%</div>
                        </div>
                      </div>
                    </div>{/* ttm-progress-bar end */}
                    {/* ttm-progress-bar */}
                    <div className="ttm-progress-bar clearfix" data-percent="80%">
                      <div className="progressbar-title">Manufacture</div>
                      <div className="progress-bar-inner">
                        <div className="progress-bar progress-bar-color-bar_skincolor">
                          <div className="progress-bar-percent ttm-bgcolor-skincolor" data-percentage={80}>80%</div>
                        </div>
                      </div>
                    </div>{/* ttm-progress-bar end */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              {/* col-img-img-two */}
              <div className="ttm-bg ttm-col-bgimage-yes col-bg-img-two ttm-right-span z-index-2 ml_80 res-991-margin_left0 margin_top70 res-991-margin_top0">
                <div className="ttm-col-wrapper-bg-layer ttm-bg-layer" />
                <div className="layer-content">
                </div>
              </div>{/* col-img-bg-img-two end*/}
              <img className="img-fluid ttm-equal-height-image w-100" src="images/bg-image/col-bgimage-2.jpg" alt="bg-image" />
            </div>
          </div>{/* row end */}
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default DesignSection